import http from './http';

export default {
  getJWT() {
    return http().get(`/v1/twilio/jwt`);
  },
  refreshJWT(data) {
    return http().post(`/v1/twilio/jwt/refresh`, data);
  },
  availableNumbers(area_code) {
    return http().get(`/v1/twilio/available_numbers?area_code=${area_code}`);
  },
  purchaseNumber(data, validationErrors = {}) {
    return http(validationErrors).post(`/v1/twilio/purchase_number`, data);
  },
  uploadVoiceMailRecording(data) {
    return http().put(`/v1/twilio/${data.id}/upload_voicemail_recording`, data);
  },
}
